import React, { Component, useEffect } from 'react';
import '../App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import learn from '../assets/learn.png'

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}

const metamask = () => {
    window.open("https://metamask.io/");
}

class Buy extends Component {

    render() {
        return (

            <div class="buyMain">
                <div class="conT" data-aos="zoom-in" data-aos-duration="700">HOW TO BUY</div>
                <div class="conT2" data-aos="zoom-in" data-aos-duration="700">Follow these easy steps to become a ANAGO holder.</div>


                <div className='boxMainT'>
                    <div>
                        <div className='box2Main' data-aos="zoom-in" data-aos-duration="700">
                            <div class="community">
                                <div class="conT2" id="boxBg"><span className='colorChange'>1.</span> Create a wallet with Metamask</div>
                                <p class="boxAbout2Txt">Visit <span className='linkHL' onClick={metamask}>metamask.io</span> and follow the simple steps to create a new account with the Metamask app or browser extension.</p>

                            </div>

                            <div class="community">
                                <div class="conT2" id="boxBg"><span className='colorChange'>2.</span> Get some $MONAD</div>
                                <p class="boxAbout2Txt">Tap the BUY button in the app to purchase MONAD, or deposit $MONAD to your Metamask wallet from the crypto exchange of your choice.</p>

                            </div>

                        </div>

                        <div className='box2Main'>

                            <div class="community">
                                <div class="conT2" id="boxBg"><span className='colorChange'>3.</span> Swap $MONAD for $ANAGO</div>
                                <p class="boxAbout2Txt">Tap the SWAP icon in your Metamask wallet and paste the $ANAGO token address. Swap your $MONAD for $ANAGO.</p>
                            </div>

                            <div class="community">
                                <div class="conT2" id="boxBg"><span className='colorChange'>4.</span> You are now a $ANAGO holder!</div>
                                <p class="boxAbout2Txt">Welcome to the #ANAGO 💜 Army!</p>
                            </div>

                        </div>
                    </div>

                    <div className='learnDiv'><img data-aos="zoom-in" data-aos-duration="700" className='learn' src={learn} /></div>
                </div>
            </div>
        )
    }
}

export default Buy;